import React from 'react';
import { observer } from 'mobx-react-lite';

import { PGWheelAnnouncementPopup } from './announcement-popup';
import { PGWheelDetailPopup } from './detail-popup';
import { useStore } from '../../../../hooks';

import './style.scss';
import { BoostedJackpot } from '../../../../jackpot/modules/boostedJackpotModule/boostedJackpot';

interface PGWheelProps {

}

export const PGWheel: React.FC<PGWheelProps> = observer(() => {

  const { boostedJackpotStore, gameStore } = useStore();
  const { isBoostedJackpotInitialPopup, isBoostedJackpotInfoPopup, wheelInfo } = boostedJackpotStore;
  const { gameReady } = gameStore;

  if (!wheelInfo || !gameReady) return null;

  return (
    <>
      {isBoostedJackpotInitialPopup && <PGWheelAnnouncementPopup wheelInfo={wheelInfo} />}
      {isBoostedJackpotInfoPopup && <PGWheelDetailPopup wheelInfo={wheelInfo} />}
      <BoostedJackpot />
    </>
  );
});
